import { services } from "../../../../constants";
import { phoneVerificationData, geolocation, profiletype, token } from "../../../store";
import { canUpdateToken, updateUserData, deleteGuestProfile } from "../tokenOperations";
import errors from "../../../errors";
import { setCookie } from "../../../../utils/cookiesUtils";
import { clearLocalCaches } from "../../media/mediaCacheDecorators";

function getSignupEndpoint(config) {
  switch (config.service) {
    case `signupWithSSO`:
      return services.ssoSignupV2;
    case "guestSignup":
      return services.guestSignupv2;
    default:
      return services.signupV2;
  }
}

/**
 * Retrieves the signup service necessary configuration to make the final request to the
 * middleware. This is the step that decides, depending on the data coming, if the signup
 * will be made to the v1 or the v2 of the signup MW endpoint.
 * @param {Object} config - Data coming to be sent in signup request.
 * @returns {Object} Object containing signup service configuration to make the final request.
 * @private
 */
async function getSignupServiceConfig(config) {
  const { smsCode, otp, paymentMethod, paymentPlanId, isOperatorActivated = false, ...restConfig } = config;
  const requestBody = restConfig;
  let signupEndpoint = getSignupEndpoint(config);
  // console.log("sdk endpoint to be called for signup" , signupEndpoint)
  // config.signupWithSSO ? services.ssoSignupV2 : config.guestSignup ? services.guestSignupv2 : services.signupV2;
  let requestHeaders = (await this.getHeaders.call(this)) || { headers: {} };

  if (!!otp) {
    if (requestBody && requestBody.userId) {
      delete requestBody.userId; // remove guest profile from OTP flows
    }

    const phoneVerificationCode = await phoneVerificationData.get.call(this);
    let extraParamsQuery = this.parseQueryString({ paymentMethod, paymentPlanId });
    if (otp && paymentMethod !== undefined && paymentPlanId !== undefined) {
      extraParamsQuery = `paymentMethod=${paymentMethod}&paymentPlanId=${paymentPlanId}&isOperatorActivated=${!isOperatorActivated}`;
      // requestHeaders = { ...requestHeaders ,  phoneVerificationCode  };
      requestHeaders.headers = { ...requestHeaders.headers, phoneVerificationCode };
    }
    if (phoneVerificationCode !== null) {
      signupEndpoint = `${services.signupV1}?otp=${otp}${!!extraParamsQuery ? `&${extraParamsQuery}` : ""}`;
      // requestHeaders = { headers: { phoneVerificationCode } };
      requestHeaders.headers = { ...requestHeaders.headers, phoneVerificationCode };
    } else {
      throw Error(errors.authentication.signup.MISSING_MANDATORY_PHONE_VERIFICATION_CODE);
    }
  }

  return { signupEndpoint, requestBody, requestHeaders };
}

const signup = {
  async run(config) {
    try {
      const guestProfile = this.guestProfie();
      const userId = guestProfile?.globalUserId || null;

      config = { ...config, ...(userId && { userId: userId }) };

      config?.country && geolocation.update({ country: config.country }); // updating country in sdk store

      const { signupEndpoint, requestBody, requestHeaders } = await getSignupServiceConfig.call(this, config);
      const response = await this.http.post(
        `${this.backendHosts.auth}${signupEndpoint}`,
        {
          ...requestBody,
          language: this.lang
        },
        requestHeaders
      );
      const spxToken = response && response.data && response.data.spx;
      const jwtCookie = this.jwtCookie;

      response?.data?.user?.profileType && profiletype.update(response?.data?.user?.profileType); // updating profileType im sdk store

      deleteGuestProfile();
      setCookie("spx-token", spxToken, jwtCookie.expirationTime); // move to updateUserData function
      setCookie("UID", Date.now());
      token.updateSPXToken.call(this, spxToken);
      if (!!config.autologin && canUpdateToken(response)) {
        updateUserData.call(
          this,
          response.data.token,
          response.data.globalUserId,
          config,
          response.data.user.profiles,
          spxToken
        );

        // TO Replicate PUT call after Login
        clearLocalCaches.call(this);
        response.data.user.freeTrial = response.data.freeTrial;
        return response.data.user;
      }
      return response.data;
    } catch (error) {
      this.handleErrorResponse(error);
    }
  }
};

//to handle guest signup. different token names

export const guestSignup = {
  async run(config) {
    try {
      config?.country && geolocation.update({ country: config.country }); // updating country in sdk store
      const { signupEndpoint, requestBody, requestHeaders } = await getSignupServiceConfig.call(this, config);
      const response = await this.http.post(
        `${this.backendHosts.auth}${signupEndpoint}`,
        {
          ...requestBody,
          language: this.lang
        },
        requestHeaders
      );
      let guestProfile = {
        "guest-spx-token": response?.data?.spx || "",
        ...response.data.user
      };
      const guestProfileType = guestProfile?.profileType || null;
      guestProfile = this.base64Enecode(JSON.stringify(guestProfile));
      setCookie("guest-profile", guestProfile, this.guestJwtCookie.expirationTime);
      setCookie("UID", Date.now());
      const spxToken = response && response.data && response.data.spx;
      token.updateSPXToken.call(this, spxToken);

      config.cookie = this.guestJwtCookie;
      const profiles = response.data?.user?.profiles;
      if (profiles && profiles.length > 0) {
        profiles[0].token = response.data.spx;
      }

      if (!!config.autologin && canUpdateToken(response)) {
        updateUserData.call(
          this,
          response.data.token,
          response.data.globalUserId,
          config,
          response.data?.user?.profiles
        );
        // TO Replicate PUT call after Login
        clearLocalCaches.call(this);
        guestProfileType && profiletype.update(guestProfileType); // updating profileType im sdk store
      }
      return response.data;
    } catch (error) {
      this.handleErrorResponse(error);
    }
  }
};

export default signup;
